import { useParams } from 'react-router';

export const parseSlug = (slug: string): [string, string] => {
  const parts = slug.split('-');
  const id = parts.pop() || '';

  return [id, parts.join('-')];
};

const useSlug = (paramName: string) => {
  const slug = useParams()[paramName] || '';

  return parseSlug(slug);
};

export default useSlug;
